var _path, _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserMikeDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.12972 9.82925C9.73357 8.95947 10.09 7.89016 10.09 6.73537C10.09 6.48678 9.89685 6.28503 9.65757 6.28503C9.41887 6.28503 9.22514 6.48678 9.22514 6.73537C9.22514 7.58274 8.99384 8.37471 8.59385 9.04567L9.12972 9.82925ZM6.72592 10.742C6.21131 10.9795 5.64261 11.1115 5.045 11.1115C2.73987 11.1115 0.864857 9.14799 0.864857 6.73537C0.864857 6.48678 0.671706 6.28503 0.432429 6.28503C0.193728 6.28503 0 6.48678 0 6.73537C0 9.49297 2.03249 11.7631 4.61297 11.993L4.61257 13.4599C4.61257 13.7085 4.8063 13.9103 5.045 13.9103C5.2837 13.9103 5.47743 13.7085 5.47743 13.4599L5.4776 11.9929C6.10304 11.9371 6.69628 11.7615 7.23618 11.4881L6.72592 10.742ZM7.66126 7.682C7.7637 7.37976 7.81946 7.05466 7.81946 6.71621V3.90128C7.81946 2.30167 6.57464 1.00049 5.045 1.00049C4.45282 1.00049 3.90333 1.1955 3.45222 1.52735L3.95376 2.26072C4.26329 2.03417 4.63962 1.90117 5.045 1.90117C6.09782 1.90117 6.95461 2.79825 6.95461 3.90128V6.6487L7.66126 7.682ZM5.32549 8.69419L5.86725 9.48637C5.60733 9.57087 5.33115 9.61641 5.045 9.61641C3.51536 9.61641 2.27054 8.31522 2.27054 6.71621V4.22709L3.1354 5.49173V6.71621C3.1354 7.81805 3.99218 8.71573 5.045 8.71573C5.14027 8.71573 5.23393 8.70838 5.32549 8.69419Z",
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: -0.6,
    x2: 14.5973,
    y2: -0.6,
    transform: "matrix(0.564498 0.825435 -0.812881 0.58243 1.00879 1)",
    stroke: "white",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserMikeDisabled);
export default __webpack_public_path__ + "static/media/userMikeDisabled.bea9630601800b6794ccd854ce113a47.svg";
export { ForwardRef as ReactComponent };